import { z } from "zod";

import { AlertFilterTypes } from "@/utils/alert";

const alertCategorySchema = z.object({
  category: z.nativeEnum(AlertFilterTypes),
  count: z.number(),
  pinned: z.boolean().catch(true),
  can_unpin: z.boolean().catch(true),
  can_sort: z.boolean().catch(true),
});

type AlertCategory = z.infer<typeof alertCategorySchema>;

export { alertCategorySchema, type AlertCategory };
